/*eslint-disable */

import axios from 'axios';
import {
  bus
} from '@/main';
import carousel from 'vue-owl-carousel'
import commonSocket from "@/commonSocket";
import countries from '@/services/country.json'
import {
  mapGetters
} from 'vuex';
import memberUserInfoPopup from '@/components/private/user/connected-user-info';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery');
let memberFiteredUrl = root.memberConnectedUsersApiUrl.link;
export default {
  name: 'member-connected-user-list',
  components: {
    carousel,
    'member-user-info-popup': memberUserInfoPopup
  },
  props: [],
  data() {
    return {
      memberAllUser: null,
      memberAllUserResults: [],
      loadmoreData: {},
      userLoading: false,
      submitted: false,
      chatRequestDetails: '',
      checkDataTaskModal: false,
      userDetails: null,
      message: '',
      nextSteper: '',
      nextPageUrl: '',
      countryList: [],
      notConnectedUserDetails: '',
      notConnectedUserPopup: false,
      connectedUserDetailsPopup: false,
      connectedUserDetails: '',
      callConfirmationPopup: false,
      callConfirmationUserDetails: '',
      calling_text: 'Yes, Call',
      is_superuser: Boolean,
      totalCountOfFilters: [],
      disabledFilters: '',
      mFilterLoading: false,
      is_guestuser: false,
      search_term: '',
      sliderTouchDrag: false,
      memUsrInfoPopupState: false,
      memUserInfo: '',
      selfUserId:''
    }
  },
  computed: {
    ...mapGetters([
      'memberConnectedUsersListGetters',
      'acUserDetailsStateGetters',
      'getConnectedMemberCountGetters'
    ]),
    getMemberFilterCountMethod() {
      this.totalCountOfFilters = this.$store.getters.getConnectedMemberCountGetters.data
      return
    },
    getmemberAllUserDetailsFun() {
      this.memberAllUser = this.$store.getters.memberConnectedUsersListGetters.data
      return
    },
    SetIntialStatus() {
      if (this.memberAllUser) {
        this.memberAllUserResults = this.memberAllUser.data
      }
      return
    },
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    SetIntialSuperUserStatus() {
      if (this.userDetails) {
        this.is_superuser = this.userDetails.is_superuser
        this.is_guestuser = this.userDetails.guest
      }
      return
    }
  },
  mounted() {
   this.selfUserId = localStorage.getItem('LoginedUserID');
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getTotalCountFilterFun
    this.getmemberAllUserDetailsFun
    this.SetIntialStatus
    this.getUserDetailsAgainFun
    bus.$on('userUpdateStatus', (data) => {
      let user = this.memberAllUserResults.find(item => item.id == data.userID);
      if (user) {
        user.is_online = data.is_online;
      }
    });
    this.SetIntialSuperUserStatus
    $(document).ready(function () {
      $(".member_search_filter_label .form-control").click(function () {
        $('.member_search_filter_label').addClass("show_search")
      })
      $(document).click(function (event) {
        if (!$(event.target).closest(".member_search_filter_label").length) {
          this.isOpen = false;
          $('.member_search_filter_label').removeClass("show_search")
        }
      });
    })
    bus.$on('memUsrInfoPopupStateBus', (data) => {
      this.memUsrInfoPopupState = data
    })
  },
  methods: {
    memUsrInfoPopupMethod(id) {
      this.memUserInfo = id
      this.memUsrInfoPopupState = true
      document.body.classList.add('notConnectedUserBody')
    },
    onResize() {
      if (window.innerWidth < 769) {
        this.sliderTouchDrag = true
      } else {
        this.sliderTouchDrag = false
      }
    },
    validateSearchMemberBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.search_term.length >= 3) {
            this.$store.dispatch('memberConnectedUserSearchFun', { search_term: this.search_term }).then((response) => {
              this.memberAllUserResults = []
              this.memberAllUserResults = response.data.data
            })
          } else if (this.search_term.length == 0) {
            axios.get(memberFiteredUrl).then((response) => {
              this.memberAllUser = response.data
              this.memberAllUserResults = response.data.data
            }).catch((err) => {
            })
          }
        }
      })
    },
    filteredMemberList(param, memberCount) {
      if (memberCount > 0) {
        if (this.disabledFilters == '' || this.disabledFilters != param) {
          this.mFilterLoading = true
          axios.get(memberFiteredUrl + '?filter_type=' + param).then((response) => {
            this.memberAllUser = response.data
            this.memberAllUserResults = response.data.data
            this.nextSteper = response.data.data.next
            this.nextPageUrl = response.data.data.next
            this.mFilterLoading = false
            $('.total_count_box').removeClass('active')
            $('#filtered' + param).addClass('active')
            this.disabledFilters = param
          }).catch((err) => {
            this.mFilterLoading = false
          })
        } else {
          this.mFilterLoading = true
          axios.get(memberFiteredUrl).then((response) => {
            this.memberAllUser = response.data
            this.memberAllUserResults = response.data.data
            this.nextSteper = response.data.data.next
            this.nextPageUrl = response.data.data.next
            this.mFilterLoading = false
            $('.total_count_box').removeClass('active')
            this.disabledFilters = ''
          }).catch((err) => {
            this.mFilterLoading = false
          })
        }
      }
    },
    notConnectedUserFun(userItems) {
      this.notConnectedUserDetails = userItems
      this.notConnectedUserPopup = true
      $('body').addClass('notConnectedUserBody')
    },
    notConnectedUserPopupClosedFun() {
      this.notConnectedUserDetails = ''
      this.notConnectedUserPopup = false
      $('body').removeClass('notConnectedUserBody')
    },
    connectedUserInfoFun(userItems) {
      this.$store.dispatch('getMemberUserDetailsFun', { id: userItems.id }).then((res) => {
        this.connectedUserDetails = res.data.data
        this.connectedUserDetailsPopup = true
        $('body').addClass('notConnectedUserBody')
      })
    },
    connectedUserInfoPopupClosedFun() {
      this.connectedUserDetails = ''
      this.connectedUserDetailsPopup = false
      $('body').removeClass('notConnectedUserBody')
    },
    userCallConfirmationFun(userItems) {
      this.callConfirmationUserDetails = userItems
      this.callConfirmationPopup = true
      $('body').addClass('notConnectedUserBody')
    },
    userCallConfirmationClosedFun() {
      this.callConfirmationUserDetails = ''
      this.callConfirmationPopup = false
      $('body').removeClass('notConnectedUserBody')
      this.calling_text = 'Yes, Call'
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
        this.loadmoreData = response.data
        this.nextSteper = this.loadmoreData.data.next
        this.$set(this.memberAllUserResults, 'next', this.nextSteper)
        if (this.loadmoreData != undefined) {
          for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
            this.memberAllUserResults.push(this.loadmoreData.data.results[i]);
            this.userLoading = false
          }
        }
      });
    },
    chatRequestSend(items) {
      this.notConnectedUserPopup = false
      this.checkDataTaskModal = true
      this.chatRequestDetails = items
    },
    closeChatRequestConfirm() {
      this.checkDataTaskModal = false,
        this.chatRequestDetails = '',
        this.message = ''
      $('body').removeClass('notConnectedUserBody')
    },
    sendChatRequestConfirm(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            from_user: this.userDetails.id,
            to_user: this.chatRequestDetails.id,
            message: this.message,
          }
          this.$store.dispatch('SendChatConnectionRequestFun', data)
            .then((res) => {
              toast.success(res.data.user_msg || res.data.msg);
              // bus.$emit('sendRequestMessage', {
              //   from_user: this.userDetails.id,
              //   to_user: this.chatRequestDetails.id
              // });
              this.checkDataTaskModal = false;
              this.chatRequestDetails = '';
              this.message = '';
              this.$store.dispatch('getAllLeftChatListDetailsFun');
              $('body').removeClass('notConnectedUserBody');
            }).catch((error) => {
              toast.error(error.data.user_msg || error.data.msg);
              this.checkDataTaskModal = false
              this.chatRequestDetails = ''
              this.message = ''
              $('body').removeClass('notConnectedUserBody')
            })
          return;
        }
      });
    },
    getCountryFlag: function (countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },

    // Video Call Request Function
    videoCallRequestFun(callerInfo) {
      this.calling_text = 'Calling..'
      let callerFullName = this.userDetails.first_name + ' ' + this.userDetails.last_name
      commonSocket.emit({
        type: "videoCalling",
        callerID: this.userDetails.id,
        callerName: callerFullName,
        targetId: callerInfo.id
      });
      commonSocket.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      commonSocket.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      commonSocket.$on('videoCallAlertPopupClosed', this.notrecievedCall);
    },
    getAnswerOfVideoCall(getAnswerData) {
      if (this.selfUserId == getAnswerData.targetId) {
        this.$router.push('/video/call/one-to-one-peer/#' + getAnswerData.roomId);
      }
    },
    getDeclinedOfVideoCall(declinedData) {
      this.calling_text = 'Yes, Call'
    },
    notrecievedCall(notrecievedData) {
      this.calling_text = 'Yes, Call'
    },
  },
  watch: {
    getMemberFilterCountMethod() {
      return this.$store.getters.getConnectedMemberCountGetters
    },
    nextSteper(old_val, new_val) {
      if (new_val != '') {
        this.nextPageUrl = new_val
        // console.log("New Val:", new_val, "OLD VAL:", old_val )
      }
    },
    getmemberAllUserDetailsFun() {
      return this.$store.getters.memberConnectedUsersListGetters
    },
    SetIntialStatus() {
      if (this.memberAllUser) {
        // this.nextSteper = this.memberAllUser.next
        this.memberAllUserResults = this.memberAllUser.data
      }
    },
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    SetIntialSuperUserStatus() {
      if (this.userDetails) {
        this.is_superuser = this.userDetails.is_superuser
        this.is_guestuser = this.userDetails.guest
      }
      return
    }
  },
  beforeCreate: function () {
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('notConnectedUserBody')
    next();
  },
  created() {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
}